@if (!isPikatukku()) {
  @if (convertDate(closingTime); as d) {
    <i
      placement="bottom"
      container="body"
      triggers="mouseenter:mouseleave click"
      popoverClass="popover-default"
      ngbPopover="{{ 'productList.closingTime.tooltip' | cxTranslate: { time: d | cxDate: 'H:mm' } }}"
    class="aimo-icon icon-sm icon-clock icon-inline icon-dark-grey"></i>
    <span class="ml-1">{{ d | cxDate: 'H:mm' }}</span>
  }
  @if (convertDate(closingTimeForTheFuture); as d) {
    <i
      placement="bottom"
      container="body"
      triggers="mouseenter:mouseleave click"
      popoverClass="popover-default"
            ngbPopover="{{
                'productList.closingTimeFuture.tooltip'
                    | cxTranslate: { time: d | cxDate: 'H:mm', date: d | cxDate: 'd.M.yyyy' }
            }}"
    class="aimo-icon icon-sm icon-clock icon-inline icon-mid-grey"></i>
  }
}
